import { render, staticRenderFns } from "./YouthHistory.vue?vue&type=template&id=0796279a"
import script from "./YouthHistory.vue?vue&type=script&lang=js"
export * from "./YouthHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports